/**
 * What: Shopify storefront survey activity merchant-facing copy.
 * Transport / data-flow: Pure string dictionary segment merged by shopify-component-copy.ts for Shopify UI consumers.
 *
 */
export const shopifyComponentWebPixelCopy = {
    webPixelActivityWebPixelActivityLogCard: {
        success001: 'Success',
        noActiveSurvey002: 'No active survey',
        disabled003: 'Disabled',
        skipped004: 'Skipped',
        needsAttention005: 'Needs attention',
        noWebPixelActivityYet006: 'No storefront survey activity yet',
        openTheStorefrontSoThe007: 'Open the storefront so survey fetches and response submissions can be recorded here.',
        loadingWebPixelActivity008: 'Loading storefront survey activity',
        unableToLoadWebPixel009: 'Unable to load storefront survey activity',
        webPixelActivity010: 'storefront-survey-activity',
        webPixelActivity011: 'Storefront survey activity',
        refresh012: 'Refresh',
        anyTrigger013: 'Any trigger',
    },
    webPixelActivityWebPixelActivityPage: {
        storefrontWebPixelActivity001: 'Storefront survey activity',
        reviewTheLatestWebPixel002: 'Review the latest survey fetches and response submissions for this store.',
        helpModalHeading: 'What this tracks',
        helpModalBody1: "This log shows when your storefront checked for a micro-survey to show, and when a shopper submitted one. It's a diagnostic trail, not shopper-level data.",
        helpModalBody2: "Nothing here identifies a specific shopper. If a survey isn't firing when you expect it to, this is the first place to check why.",
    },
};
//# sourceMappingURL=web-pixel.js.map